<template>
  <ul :id="`tree-node-actions-${nodo.id}`">
    <li>
      <a
        class="a-tooltip-primary a-tooltip-bottom"
        :data-tooltip-text="$t('mEditionAssetContentsTreeNodeActions.actions.comments')"
        href="#"
        @click.prevent="selectNode"
      >
        <i :class="[nodo.id === $store.getters.getAssetSelectedNode.id
          ? 'text-color-assets-primary' : '', 'fas fa-comments']"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentsTreeNodeComments',

  props: {
    contenido: Object,
    nodo: Object
  },

  methods: {
    selectNode () {
      this.$store.commit('setAssetSelectedNode', this.nodo)
    }
  }
}
</script>
